import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import { TReturnType } from '@r1-frontend/service-engineer-visit/types/TReturnType';

const getConfirmBody = (state: TInitialState): TReturnType => {
    const {
        selected,
        _incomingData,
    } = state;

    if (!_incomingData) {
        throw new Error('Incoming data is not set');
    }

    const result = {
        date: `${selected.date}`,
        hour: `${selected.hour}:00`,
    } as TReturnType;

    if (selected.deliveryOption) {
        result['deliveryType'] = String(selected.deliveryOption.name);
        result['deliveryCost'] = Number(selected.deliveryOption.cost);
    }

    if (_incomingData.withComment) {
        result['comment'] = selected.comment;
    }

    return result;
};

export default getConfirmBody;
